import React from 'react'
import { string } from 'prop-types'

const General = ({ content }) => <p>{content}</p>

General.propTypes = {
  content: string.isRequired,
}

export default General



// WEBPACK FOOTER //
// ./src/components/ToastsComponents/General/index.jsx